module.exports = __webpack_public_path__ + "img/icon.c3e31104.jpg";